// extracted by mini-css-extract-plugin
export default {"faqs":"ht-z","faqContent":"it-z","faq":"jt-z"};